import { QBankStructureLevelCategory, useQBankStructure } from '@exam-management/qbs-provider';
import { LocationFormFields } from '@exam-management/qcontent-management';
import { Box, Flex, Text } from '@shared/components';
import { useMemo } from 'react';

export default function QuestionDuplicationCustomLocation() {
  const { qBankStructureLevelItems, qBankStructureInformation, qBankStructureLevels } =
    useQBankStructure();
  const { name } = qBankStructureInformation;

  const qBankStructureLevelsExcludingCourse = useMemo(() => {
    return qBankStructureLevels.filter(
      (level) => level.category !== QBankStructureLevelCategory.Course,
    );
  }, [qBankStructureLevels]);

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
      <Box
        sx={(theme) => ({
          p: theme.spacing(3, 4),
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: theme.shape.rounded(2),
          bgcolor: theme.palette.grey[50],
          width: '100%',
          textAlign: 'center',
        })}
      >
        <Text variant='body2Semibold'>{name}</Text>
      </Box>
      <Text variant='body1'>Select location to duplicate</Text>
      <LocationFormFields
        qbsLevels={qBankStructureLevelsExcludingCourse}
        qbsLevelItems={qBankStructureLevelItems}
      />
    </Flex>
  );
}
